<app-standard-page>
  <app-standard-page-content [limitWidth]="true">
    <div class="card-body">
      <div class="row mt-4">
        <div class="col-12">
          <h1 class="text-primary">
            Your {{ 'organisation' | ize }} invite has expired
          </h1>

          <p>Please contact the sender to have your invitation re-issued.</p>
        </div>
      </div>
    </div>
  </app-standard-page-content>
</app-standard-page>
